import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'
import Dropzone from 'react-dropzone'
import axios from 'axios'

// import other components within the same project here
import Config from "composer/Config.jsx";

import Localization from "composer/Localization.jsx"
import GoogleImageSearchDialog from "composer/views/GoogleImageSearchDialog.jsx"
import ReactAudioPlayer from 'react-audio-player';
import Lightbox from 'react-images';

import { Button, Card, CardHeader, CardMedia, CardContent, Icon, CircularProgress } from '@material-ui/core';
import {
  grey,
} from '@material-ui/core/colors'

var CancelToken = axios.CancelToken;
var cancelRequest;

class FilePicker extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      fileID: "",
      fileUrl: "",
      previewUrl: "",
      fileDetails: "",
      fileInstruction: "",
      isUploading: false,
      uploadProgress: 0,
      fileTypeIcon: "create_new_folder",
      extensionText: "",
      lightboxIsOpen: false,
      uploadID: "",
      fileIDPendingDelete: "",
    };
    autoBind(this);
    if (this.props.allowedExtension) {
      this.state.extensionText = Localization.strings.FILE_TYPE + ": " + this.props.allowedExtension.replace(/,/g, " / ");
      this.state.fileDetails = this.state.extensionText;
    }
    let fileType = this.props.fileType;
    if (fileType == "image") {
      this.state.fileTypeIcon = "add_photo_alternate";
    }
    else if (fileType == "audio") {
      this.state.fileTypeIcon = "audiotrack";
    }
    else if (fileType == "video") {
      this.state.fileTypeIcon = "local_movies";
    }
    if (this.props.fileInstruction) {
      this.state.fileInstruction = this.props.fileInstruction;
    }
    if (this.props.filePath) {
      this.state.fileUrl = this.props.filePath;
    }
    if (this.props.previewPath) {
      this.state.previewUrl = this.props.previewPath;
    }
    if (this.props.uploadID) {
      this.state.uploadID = this.props.uploadID;
    }
    if (this.props.fileID) {
      this.state.fileID = this.props.fileID;
    }
  }

  getFileExtension(filename) {
    return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
  }

  checkFileExtension(filename, allowedExtension) {
    let fileOK = false;

    if (allowedExtension == undefined || allowedExtension == "") {
      return true;
    }

    filename = filename.toLowerCase();
    allowedExtension = allowedExtension.toLowerCase();

    let extension = this.getFileExtension(filename);
    if (extension == undefined) {
      return false;
    }

    extension = extension.trim();
    let extensionArray = allowedExtension.split(',');
    for (let i = 0; i < extensionArray.length; i++) {
      if (extension == extensionArray[i].trim()) {
        fileOK = true;
      }
    }

    return fileOK;
  }

  checkFileSize(fileSize, sizeLimit) {
    return fileSize <= sizeLimit;
  }

  handleChangeClicked() {
    let dialogText = {
      title: Localization.strings.DELETE,
      content: Localization.strings.DELETE_REMINDER,
      confirm: Localization.strings.DELETE,
    };
    console.log("on delete file clicked"); 
    this.props.root.refs.confirmDialog.show(dialogText, this.changeFileConfirmClicked, this.changeFileCancelClicked);
  }

  changeFileConfirmClicked() {
    this.setState({
      fileUrl: "",
      previewUrl: "",
      fileDetails: this.state.extensionText,
    });
    this.state.fileUrl = "";
    this.state.previewUrl = "";
    this.state.fileDetails = this.state.extensionText;

    if (this.state.fileID != "") {
      this.setState({
        fileIDPendingDelete: this.state.fileID,
      });
      this.state.fileIDPendingDelete = this.state.fileID;
    }

    // reset payload
    try{
      this.props.onDeleteFile(this.state.fileID);
    }catch(error){
      console.log(error);
    }
  }

  deleteFile() {
    if (this.state.fileIDPendingDelete != "") {
      let requestObj = { file_id: this.state.fileIDPendingDelete };
      this.props.root.refs.API.request("delete_file", requestObj, this.deleteFileOK, this.deleteFileFailed);
    }
  }

  deleteFileOK(res) {
    console.log("delete file ok");
    this.setState({
      fileIDPendingDelete: "",
    });
    this.state.fileIDPendingDelete = "";
  }

  deleteFileFailed(err) {
    console.log("delete file failed " + err);
  }

  changeFileCancelClicked() {

  }

  abortUpload() {
    this.setState({ isUploading: false });
    this.state.isUploading = false;
    this.resetUploadProgress();
    if (this.props.onAbortUpload != null) {
      this.props.onAbortUpload();
    }
    this.props.root.addNotification(Localization.strings.UPLOAD_FAILED, false);
  }

  resetUploadProgress() {
    this.setState({ uploadProgress: 0 });
    this.state.uploadProgress = 0;
  }

  imageSearchClicked() {
    this.refs.googleImageSearchDialog.setState({ open: true });
  }

  imagePreviewClicked() {
    this.setState({ lightboxIsOpen: true });
    this.state.lightboxIsOpen = true;
  }

  imageFullClicked() {
    this.setState({ lightboxIsOpen: false });
    this.state.lightboxIsOpen = false;
  }

  handleUploadProgress(progressEvent) {
    var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );

    this.setState({ isUploading: true });
    this.state.isUploading = true;
    this.setState({ uploadProgress: percentCompleted });
    this.state.uploadProgress = percentCompleted;
  }

  handleUploadResponse(response) {
    if (response.status == 200) {
      if (this.props.onUploadSuccess != null) {
        let resp = response.data;
        resp.uploadID = this.state.uploadID;
        this.props.onUploadSuccess(resp);

        let url = Config.UPLOAD_PATH() + resp.tn_path;
        this.setState({
          uploadProgress: 100,
          isUploading: false,
          fileUrl: url,
          previewUrl: url,
        });
        this.state.uploadProgress = 100;
        this.state.isUploading = false;
        this.state.fileUrl = url;
        this.state.previewUrl = url;
        this.props.root.addNotification(Localization.strings.UPLOADED, true);
        this.deleteFile();
      }
    }
  }

  uploadFile(files, progressCallback, responseCallback) {
    if (files.length > 0) {
      let oneMB = 1024 * 1024;
      let file = files[0];
      let fileOK = false;
      let fileSize = parseInt(file.size);
      fileOK = this.checkFileExtension(file['name'], this.props.allowedExtension? this.props.allowedExtension : "");
      if (!fileOK) {
        this.props.root.addNotification(Localization.strings.UPLOAD_FILE_TYPE_REMINDER, false);
      }
      if (fileOK) {
        let sizeLimit = (this.props.sizeLimit? this.props.sizeLimit : oneMB);
        fileOK = this.checkFileSize(fileSize, sizeLimit);
        if (!fileOK) {
          let message = Localization.strings.UPLOAD_FILE_SIZE_REMINDER + " " + parseFloat(sizeLimit / oneMB).toFixed(1) + "MB";
          this.props.root.addNotification(message, false);
        }
      }

      if (fileOK) {
        let formData = new FormData();
        formData.append(
          "Filedata",
          file,
          file.name
        );

        var config = {
          onUploadProgress: function(progressEvent) {
            progressCallback(progressEvent);
          },
          params: {
            key: Config.FILE_SERVER_KEY(),
            epack_id: (this.props.epackID? this.props.epackID : 0),
            user_id: this.props.root.getMyUserId(),
          },
          cancelToken: new CancelToken(function executor(c) {
            cancelRequest = c;
          }),
        }

        axios.post(Config.UPLOAD_API_PATH(), formData, config)
          .then(function (response) {
            responseCallback(response);
          })
          .catch(function(error){
            console.log(error);
          });
      }
    }
  }

  cancelUpload() {
    if (cancelRequest != null) {
      cancelRequest();
      cancelRequest = null;
    }
    this.abortUpload();
  }

  render() {
    return (
      <div style={{margin:"0 5px 10px 5px"}}>
        <div style={{display:'none'}}>
          <GoogleImageSearchDialog root={this.props.root} parent={this} ref="googleImageSearchDialog" />
        </div>
        <Card>
          <CardHeader
            title={this.props.pickerTitle? this.props.pickerTitle : ""}
          />
          <CardMedia image="/">
            <div style={{backgroundColor:grey[100], height:"20vh"}}>
              <If condition={this.state.isUploading}>
                <Then>
                  <div style={{width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center'}}>
                    <div style={{textAlign:'center', verticalAlign:'middle'}}>
                      <CircularProgress
                        variant="indeterminate"
                        value={this.state.uploadProgress}
                      />
                      <br/>
                      {Localization.strings.UPLOADING + "..." + parseInt(this.state.uploadProgress) + "%"}
                      <Button onClick={this.cancelUpload}>{Localization.strings.CANCEL}</Button>
                    </div>
                  </div>
                </Then>
                <Else>
                  <If condition={this.state.fileUrl == ""}>
                    <Then>
                      <div style={{width:'100%', height:'100%'}}>
                        <Dropzone onDrop={acceptedFiles => this.uploadFile(acceptedFiles, this.handleUploadProgress, this.handleUploadResponse)}>
                          {({getRootProps, getInputProps}) => (
                              <div style={{width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center'}} {...getRootProps()}>
                                <input {...getInputProps()} />
                                <p style={{fontWeight:'bold'}}>{Localization.strings.DROP_FILE_HERE_OR_CLICK_TO_SELECT}</p>
                              </div>
                          )}
                        </Dropzone>
                      </div>
                    </Then>
                    <Else>
                      <div style={{width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center'}}>
                        <If condition={this.props.fileType=="audio"}>
                          <Then>
                            <ReactAudioPlayer
                              src={this.state.fileUrl}
                              controls
                              style={{display:"block", margin:"auto"}}
                            />
                          </Then>
                          <Else>
                            <img alt="" style={{cursor: "pointer", height:"20vh", maxHeight:"100%", maxWidth:"100%", display:"block", margin:"auto"}} src={this.state.fileUrl} onClick={this.imagePreviewClicked}/>
                          </Else>
                        </If>
                      </div>
                    </Else>
                  </If>
                </Else>
              </If>
            </div>
          </CardMedia>
          <CardContent>
            <div style={{textAlign:"center"}}>
              {this.state.fileDetails + " "}
              <If condition={this.state.fileUrl != ""}>
                <Then>
                  <Button color="primary" onClick={this.handleChangeClicked}>
                    <Icon className="buttonIconLeft">delete</Icon>
                    {Localization.strings.DELETE}
                  </Button>
                </Then>
              </If>
            </div>
            <div>
              <If condition={this.state.fileInstruction != ""}>
                <Then>
                  {this.state.fileInstruction.split('\n').map((item ,key) => {
                    return (
                      <span key={key}>
                        {item}
                        <br/>
                      </span>
                    )
                  })}
                </Then>
              </If>
            </div>
          </CardContent>
        </Card>
        <Lightbox
          images={[{src:this.state.fileUrl}]}
          isOpen={this.state.lightboxIsOpen}
          onClickImage={this.imageFullClicked}
          onClose={this.imageFullClicked}
          backdropClosesModal={true}
          showImageCount={false}
        />
      </div>
    )
  }
}

export default FilePicker;
